import { __awaiter } from "tslib";
import { notify } from "@phoenixreisen/reacts/src/notification";
import React, { useEffect, useState } from "react";
import { getWebtexts } from "../../shared/models/api";
import Loader from "@phoenixreisen/reacts/src/loader";
import { Link, useNavigate } from "react-router-dom";
import Model from "../../shared/models/model";
import isIBAN from "validator/lib/isIBAN";
import Config from "../../../../config";
import striptags from "striptags";
export const PaymentForm = () => {
    var _a;
    const navigate = useNavigate();
    const { html } = Config;
    const { customer } = Model;
    const [wts, setWts] = useState(Model.webtexts);
    const [initiated, setInitiated] = useState(false);
    const [confirmed, setConfirmed] = useState(false);
    const [payment, setPayment] = useState("Lastschrift");
    const [errors, setErrors] = useState({});
    const [iban, setIban] = useState((customer === null || customer === void 0 ? void 0 : customer.iban) || "");
    const save = () => {
        Model.payment.method = payment;
        Model.payment.iban = payment === "Lastschrift" ? iban : null;
    };
    const isDisabled = () => {
        if (customer === null || customer === void 0 ? void 0 : customer.iban) {
            return true;
        }
        else if (!(customer === null || customer === void 0 ? void 0 : customer.iban) && Model.customerFromDatabase) {
            return true;
        }
        return false;
    };
    const next = (e) => {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        if ((payment === "Lastschrift" && isIBAN(iban) && confirmed) ||
            payment === "Rechnung") {
            save();
            navigate("/zusammenfassung");
        }
        else {
            notify({
                status: "error",
                text: "Bitte füllen Sie alle Felder aus.",
            });
        }
    };
    useEffect(() => {
        const { visitors, customer, payment } = Model;
        if (!(visitors === null || visitors === void 0 ? void 0 : visitors.length) || !visitors[0].v.surname || !customer) {
            navigate("/besucher");
        }
        else {
            if (payment.iban)
                setIban(payment.iban);
            if (payment.method)
                setPayment(payment.method);
            if (customer === null || customer === void 0 ? void 0 : customer.iban) {
                payment.method = "Lastschrift";
                setPayment(payment.method);
            }
            if (!(customer === null || customer === void 0 ? void 0 : customer.iban) && Model.customerFromDatabase) {
                payment.method = "Rechnung";
                setPayment(payment.method);
            }
            setInitiated(true);
        }
    }, []);
    useEffect(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            const result = yield getWebtexts();
            setWts(result);
        }))();
    }, [wts]);
    if (!wts || !initiated) {
        return React.createElement(Loader, null);
    }
    return (React.createElement("section", { className: "payment" },
        React.createElement("h3", { className: "pt0" }, "Zahlungsart"),
        React.createElement("form", { onSubmit: (e) => next(e) },
            React.createElement("div", { className: "form-box" },
                React.createElement("p", null, "Wie m\u00F6chten Sie bezahlen?"),
                React.createElement("label", { className: "select" },
                    React.createElement("select", { name: "payment", value: payment, disabled: isDisabled(), onChange: (e) => setPayment(e.target.value) },
                        React.createElement("option", { value: "" }, "Bitte ausw\u00E4hlen"),
                        React.createElement("option", { value: "Rechnung" }, "Rechnung"),
                        React.createElement("option", { value: "Lastschrift" }, "Lastschrift")),
                    React.createElement("span", { className: "select__label" }, "Zahlungsart")),
                payment === "Lastschrift" && (React.createElement(React.Fragment, null,
                    React.createElement("div", null,
                        React.createElement("div", { dangerouslySetInnerHTML: {
                                __html: striptags(wts["sb_lastschrift"], html.allowed),
                            } })),
                    errors.iban && (React.createElement("div", { className: "alert alert--danger alert--icon" },
                        React.createElement("i", { className: "fas fa-exclamation-triangle" }),
                        "Bitte \u00FCberpr\u00FCfen Sie Ihre Eingabe. Es scheint sich nicht um eine valide Iban zu handeln.")),
                    React.createElement("label", { className: "textfield date" },
                        React.createElement("input", { id: "iban", type: "text", name: "iban", value: iban, maxLength: 50, placeholder: "Ihre IBAN...", disabled: ((_a = customer === null || customer === void 0 ? void 0 : customer.iban) === null || _a === void 0 ? void 0 : _a.length) > 0, onInput: (e) => setIban(e.target.value), onBlur: () => iban && setErrors({ iban: !isIBAN(iban) }) }),
                        React.createElement("span", { className: `textfield__label ${errors.iban ? "alert--warning" : ""}` }, "IBAN")),
                    React.createElement("label", { className: "checkbox" },
                        React.createElement("input", { type: "checkbox", name: "confirmation", checked: confirmed, onChange: () => setConfirmed(!confirmed) }),
                        React.createElement("span", { className: "checkbox__label" }, wts["sb_lastschrift_label"]))))),
            React.createElement("div", { className: "mt3 flex justify-between" },
                React.createElement("div", null,
                    React.createElement(Link, { to: "/besucher", onClick: () => save(), className: "btn btn--link" },
                        React.createElement("i", { className: "fas fa-arrow-left mr2" }),
                        "Zur\u00FCck")),
                React.createElement("div", null,
                    React.createElement("button", { type: "submit" },
                        "Weiter ",
                        React.createElement("i", { className: "fas fa-arrow-right ml2" })))))));
};
export default PaymentForm;
